import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import { ConnectionService, ConfirmService } from '@luzula/luzula-lib';

@Component({
    standalone: false,
    selector: 'bp-auth-button',
    templateUrl: './auth-button.component.html',
    styleUrls: ['./auth-button.component.css'],

})
export class AuthButtonComponent implements OnInit {
	auth = inject(AuthService);
	cs = inject(ConnectionService);
	confirmService = inject(ConfirmService);

	@Output() loggedOut = new EventEmitter<void>();
	isOnline:boolean = navigator.onLine;

	constructor() {
		this.cs.monitor().subscribe((online: boolean) => {
			this.isOnline = online;
		})
	}

	ngOnInit(): void { }

	openLogin(): void {
		this.auth.login().subscribe();
	}

	async onLogout() {
		if (!this.isOnline) return;
		const confirmed = await this.confirmService.confirm({
			title: 'Abmelden',
			message: 'Wenn Sie sich abmelden, können Sie keine Daten mehr ändern. Die Daten bleiben aber erhalten.\n\nMöchten Sie sich trotzdem abmelden?',
			confirmText: 'Abmelden',
			confirmClass: 'btn-warning'
		});
		if (confirmed) {
			this.auth.logout(() => this.loggedOut.emit());
		}
	}
}
